<script lang="ts">
    export let flag: Flag;
    export let width: number | string = 16;
    export let height: number | string = width;
    $: _width = parseFloat(`${width}`);
</script>

<svg {width} {height}>
    <g>
        {#each flag.colors as color, j}
            <rect
                x={Math.floor(j * (_width / flag.colors.length))}
                y={0}
                width={Math.ceil(_width / flag.colors.length)}
                {height}
                fill={`#${color}`}
            ></rect>
        {/each}
    </g>
</svg>
